import parseDomain from './parseDomain';

export function isEmail(email: string): boolean {
  // any characters [anything except period and dash] @ any characters . [2 or more word-letters]

  // must be string
  if (typeof email !== 'string') {
    return false;
  }
  // can't have dot or dash preceding @
  if (/[.-]@/.test(email)) {
    return false;
  }

  if (!/^[a-z0-9]+.*@.+\.\w{2,}/i.test(email)) {
    return false;
  }

  const domain = email.split('@')[1];
  if (!domain) {
    return false;
  }

  try {
    parseDomain(domain);
  } catch {
    return false;
  }

  return true;
}
